export const TYPING = 'TYPING';